import { getClockTime } from '../../../utils/get-clock-time';
import { getFormattedDate } from '../../../utils/get-formatted-date';
import { Tooltip } from '../../../../common/components/tooltip';
import { BaseQueueCell } from '../../base-queue-cell';

export function TimeCell({ dateStr }: { dateStr: string | undefined }): React.ReactElement {
    if (!dateStr) {
        return <BaseQueueCell />;
    }
    return (
        <BaseQueueCell alignment="CENTER">
            <Tooltip overlay={getFormattedDate(dateStr)}>
                <span>{getClockTime(dateStr)}</span>
            </Tooltip>
        </BaseQueueCell>
    );
}
